import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TARIFAS } from '@appNeo/admin/configuracion/datos-estaticos-demo';
import { ITarifa } from '@appNeo/core/interfaces/ITarifa';
import { DISABLE_DELAY_LOADER, LOADER_TRANSPARENT } from '@appNeo/neoCore/interceptors/loaderInterceptor/loader.interceptor';
import { TipoPaginadorEnum } from '@appNeo/neoShared/helpers/enums/TipoPaginador.enum';
import { IRespApi } from '@appNeo/neoShared/helpers/interfaces/IResp-api';
import { Paginator } from '@appNeo/neoShared/models/paginator/paginator';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { environment } from '@environments/environment';
import { BehaviorSubject, catchError, forkJoin, map, Observable, of, Subject, tap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TarifasService {

  public editando$ = new BehaviorSubject<boolean>(false);

  urlEntidad = environment.api_url + '/tarifas';
  contextLoader = { context: new HttpContext().set(DISABLE_DELAY_LOADER, true) };
  contextLoaderTransparent = { context: new HttpContext().set(LOADER_TRANSPARENT, true) };

  public error422Api$: Subject<IRespApi> = new Subject<IRespApi>();
  public tarifa$: BehaviorSubject<ITarifa> = new BehaviorSubject<ITarifa>(null);
  public tarifas$: BehaviorSubject<ITarifa[]> = new BehaviorSubject<ITarifa[]>(null);
  public totalTarifas$: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  constructor(
    private http: HttpClient,
    private auxiliar: AuxiliarService
  ) { }

  set tarifa(tarifa: ITarifa) {
    if (tarifa) {
      // this.entidadesRelacionadas( tarifa ).subscribe( response => {
      let tarifaMapeada = { ...tarifa };
      this.tarifa$.next(tarifaMapeada);
      // })
    }

  }

  set editando(flag: boolean) {
    this.editando$.next(flag);
  }

  getAll(tipoPaginador?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<ITarifa[]> {
    // return new Observable<any>( observer => {
    //   this.totalTarifas$.next( TARIFAS.length );
    //   this.tarifas$.next( this.mapearEntidades(TARIFAS) );
    //   observer.next(this.mapearEntidades(TARIFAS));
    //   observer.complete();
    // });     
    let request = (tipoPaginador === TipoPaginadorEnum.offline)
      ? this.urlEntidad
      : `${this.urlEntidad}?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`;
    // TODO: Eliminar contextLoader, añadido para pruebas loader
    return this.http.get(request, { ... this.contextLoaderTransparent }).pipe(
      tap((data: IRespApi) => this.totalTarifas$.next(data.total)),
      tap((data: IRespApi) => this.tarifas$.next(this.mapearEntidades(data.data))),
      map((data: IRespApi) => this.mapearEntidades(data.data)),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestAllTarifaAdmin');
      }));
  }

  get(id): Observable<ITarifa> {
    // let tarifa  = TARIFAS.filter(tarifa => tarifa.id === id).pop();
    // return new Observable<any>( observer => {
    //   observer.next(tarifa);
    //   observer.complete();
    // });    
    return this.http.get(`${this.urlEntidad}/${id}`).pipe(
      map((data: IRespApi) => this.mapearEntidad(data['data'])),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestGetTarifaAdmin');
      }));
  }

  mapearEntidades(tarifas: ITarifa[]) {
    if (tarifas.length) {
      tarifas.forEach((element, index) => {
        tarifas[index] = this.mapearEntidad(element);
      });
    }
    return tarifas;
  }

  mapearEntidad(entidad: ITarifa): ITarifa {
    let item = Object.assign({}, entidad);
    if (item?.activa) {
      item.activa = this.auxiliar.getBoolean(item.activa);
      item.identificador = (item.identificador) ? item.identificador : item.id;
    }
    let _item = { ...item };
    return _item;
  }

  create(request: any): Observable<any> {
    return this.http.post<IRespApi>(`${this.urlEntidad}`, request).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostTarifa');
      })
    );
  }

  update(id: string, request: any) {
    return this.http.put(`${this.urlEntidad}/${id}`, request).pipe(
      map((data: IRespApi) => data['data']),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPutTarifa');
      })
    );
  }

  delete(id: string) {
    return this.http.delete(`${this.urlEntidad}/${id}`).pipe(
      map((valor: string) => this.auxiliar.getBoolean(valor)),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestDeleteTarifa');
      })
    );
  }

  /************************************ 
  * Funciones apoyo                  *
  *************************************/
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let peticion = {
      listadoEntidad: this.getAll().pipe(
        catchError(err => of(null))
      )
    };
    const id = route.params.id;
    if (id) {
      peticion['entidad'] = this.get(id).pipe(
        catchError(err => of(null))
      )
    }
    return forkJoin(peticion);
  }

  private handleError(err: IRespApi, idRequest = '') {
    // dialog específico
    console.log('CODIGO ERROR ', err);
    if (err.codigoError === 422) {
      console.log('Este es el error 422', err.codigoError);
      err.request = idRequest;
      this.error422Api$.next(err);
    }

    // pantalla común
    let mensaje = err?.mensaje;
    if (err.codigoError === 403) {
      mensaje = `${err.mensaje}: `;
      err.data.forEach(element => {
        mensaje += element.mensaje;
      });
    }
    if (err.codigoError === 404) {
      let avisos = '';
      if (err.data) {
        if (typeof err.data === 'string') {
          avisos = err.data;
        } else {
          err.data.forEach(element => {
            if (element.id === 999) {
              avisos = ' ' + element.mensaje + ' ';
            }
          });
        }
      }
      mensaje = err?.mensaje + avisos;
    }
    return throwError({ 'error': true, 'data': err.data, mensaje });
  }
}
